<template>
<div class="shopMobTopSetting box-shadow">
    <div class="setting" v-show="selectCom.name === 'header'">
        <span>页面名称</span>
        <el-input placeholder="请输入内容" v-model="pagename"></el-input>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'shopMobTopSetting',
    data() {
        return {
            isVisited: false,
            item: {
                cominnerid: '',
                label: '头部',
                comtype: 'header',
                isdisplaytitle: 1,
                titlename: '',
                isdisplayall: 1,
                datasource: 1,
                liststyle: 'detail',
                tagname: '',
                taginnerid: '',
                datacount: 2,
                datalist: []
            },
            pagename: ''
        }
    },
    mounted() {
        this.pagename = this.smallPageName
    },
    methods: {
        ...mapActions([
            'setSmallPageName'
        ])
    },
    computed: {
        ...mapGetters([
            'smallPageName',
            'selectCom'
        ])
    },
    watch: {
        'pagename': {
            handler: function() {
                this.setSmallPageName(this.pagename)
            }
        }
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.shopMobTopSetting{
    width: 548px;
    height: 72px;
    position: absolute;
    top: 0px !important;
    left: 102%;
    .setting{
        background: #F5F7FA;
        padding: 20px;
        color: #303133;
        .el-input{
            width: 440px;
            margin-left: 5px;
        }
    }
}
</style>
